<template>
    <div>
        <div class="popup popup-stateroom" :class="{ 'modal-in': isShow, 'modal-out': !isShow}" id="contactList">
            <div class="js-returnDetailBtn">
                <a class="returnButton" @click="onGoBack()">
                    <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
                </a>
                <p class="popup-title">选择联系人</p>
            </div>
            <div class="list-contacts-content scroll-container" style="">
                <div class="contactsEdit-content">
                    <div class="fillPassenger-title">
                        <div class="fillPassenger-title-l">
                            选择航线联系人/乘客
                        </div>
                        <div class="fillPassenger-title-r" @click="contactNewClick($event)">
                            <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon04.png">
                            新增乘客
                        </div>
                    </div>
                    <div v-if="descText" class="fillPassenger-desc">{{descText}}</div>
                    <div class="passenger-details-content scroll-container js-smartScroll" :class="{'is-desc': descText}">
                        <div class="passenger-detail border-grey" v-for="(contact, i) in contacts" :key="('contact_'+i)"
                        @click="onContactClick($event, contact)">
                            <div class="detail-edit-img">
                                <img class="noPicthOn" v-show="!isSelected(contact)"
                                    src="https://resource.rcclchina.com.cn/mobileSearchPackage/selectIcon.png">
                                <img class="picthOn"
                                    v-show="isSelected(contact)"
                                    src="https://resource.rcclchina.com.cn/mobileSearchPackage/selectedIcon.png">
                            </div>
                            <div class="detail-edit-intro">
                                <div class="edit-intro-name">
                                    <span class="chinese-name" v-show="contact.chineseLastName || contact.chineseFirstName">
                                        {{contact.chineseLastName || ''}}{{contact.chineseFirstName || ''}}
                                    </span>
                                    <span class="pinyin-name">{{contact.pinyinLastName}} {{contact.pinyinFirstName}}</span>
                                </div>
                                <div class="edit-intro-birth">
                                    <span class="male">{{getContactGender(contact)}}</span>
                                    <span class="birth" v-show="contact.dateOfBirth && contact.dateOfBirth.length > 0">{{contact.dateOfBirth}}</span>
                                    <span class="passenger-passport" v-show="contact.passportNum&&contact.passportNum.length > 0">{{contact.passportNum}}</span>
                                </div>
                            </div>
                            <div class="edit-img" @click="contactEditClick($event, contact)">
                                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/editBtn.png">
                            </div>
                        </div>
                    </div>
                    <div class="selectAddContacts" @click="confirmContact">确定</div>
                </div>
            </div>
        </div>

        <GuestInfoContactEdit
            :targetContact="targetContact"
            :isNewContact="isNewContact"
            :isShow="isShowContactEdit"
            :onGoBack="onCloseContactEdit"
            :onSubmitSuccess="onSubmitSuccess"
        />
    </div>
</template>

<script>
import api from '@/api'
const GuestInfoContactEdit = () => import('@/components/Booking/GuestInfoContactEdit')
export default {
    name: "GuestInfoContactList",
    components: {
        GuestInfoContactEdit
    },
    props: {
        maxCount: {
            type: Number,
            default () {
                return 1
            }
        },
        contactMode: {
            type: String
        },
        selectContactIds: {
            type: Array,
            default () {
                return []
            }
        },
        onNewContactClick: {
            type: Function
        },
        onEditContactClick: {
            type: Function
        },
        onGoBack: {
            type: Function
        },
        onBookingContactConfirm: {
            type: Function
        },
        onGuestContactConfirm: {
            type: Function
        },
        closeContactEdit: {
            type: Function
        },
        showContactEdit: {
            type: Function
        },
        isShow: {
            type: Boolean,
            default() {
                return false
            }
        },
        isShowContactEditPopup: {
            type: Boolean,
            default() {
                return false
            }
        },
        descText: {
          type: String,
          default() {
            return ''
          }
        },
    },
    data () {
        return {
            contacts: [],
            selectedContacts: [],
            targetContact: {},
            isNewContact: false,
            isShowContactEdit: false
        }
    },
    beforeMount () {
        this.initPage()
    },
    methods: {
        async initPage(isEdit=false) {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                return
            }
            this.$loading.show()
            let searchType = this.contactMode === 'contact' ? 1 : 2
            const { data } = await api.user.getContact(userToken,searchType)
            this.$loading.hide()
            if (data && data.length > 0) {
              this.contacts = data
              //编辑之后返回，对选中用户信息进行更新
              if(isEdit) {
                this.updateSelectedContacts();
              }
            }
        },
        //更新修改后的选中用户列表
        updateSelectedContacts() {
          let selectedContacts = [];
          this.selectedContacts.forEach((row)=> {
            this.contacts.forEach((r)=> {
              if(r.id === row.id) {
                selectedContacts.push(r);
              }
            })
          });
          this.selectedContacts = [...selectedContacts];
        },
        getContactCNName(contact) {
            if (contact.chineseLastName && contact.chineseLastName.length > 0
            && contact.chineseFirstName && contact.chineseFirstName.length > 0) {
                return `${contact.chineseLastName}${contact.chineseFirstName}`
            }
            return ''
        },
        getContactGender(contact) {
            if (contact.gender == 'M') return '男'
            else if (contact.gender == 'F') return '女'
            return ''
        },
        isSelected (contact) {
            return this.selectedContacts.some(r=>r.id == contact.id)
        },
        onContactClick(e, contact) {
            e.stopPropagation()
            if (this.maxCount == 1 || this.contactMode == 'contact') {
                this.selectedContacts = [contact]
            } else {
                if (this.selectedContacts.some(r=>r.id == contact.id)) {
                    // 反选
                    this.selectedContacts = this.selectedContacts.filter(r=>r.id != contact.id)
                } else {
                    if (this.selectedContacts.length >= this.maxCount) {
                        this.$alert.show(`该舱房最多可选${this.maxCount}名乘客`)
                        return
                    }
                    this.selectedContacts.push(contact)
                }
            }
        },
        confirmContact() {
            if (this.contactMode == 'contact') {
                if (this.selectedContacts.length == 0) {
                    return
                }
                this.onBookingContactConfirm(this.selectedContacts[0], 'confirmContact')
            } else {
                this.onGuestContactConfirm(this.selectedContacts)
            }
        },
        contactEditClick(e, contact) {
            e.stopPropagation()
            this.targetContact = contact
            this.isNewContact = false
            this.isShowContactEdit = true
            this.showContactEdit()
        },
        contactNewClick(e) {
            e.stopPropagation()
            this.targetContact = {}
            this.isNewContact = true
            this.isShowContactEdit = true
            this.showContactEdit()
        },
        onCloseContactEdit () {
            this.isShowContactEdit = false
            this.closeContactEdit()
        },
        async onSubmitSuccess() {
            await this.initPage(true)
            this.onCloseContactEdit()
            this.$emit('updateContactList')
        }
    },
    watch: {
        selectContactIds (newOne) {
          this.selectedContacts = this.contacts.filter(r=> newOne.indexOf(r.id) >= 0)
        },
        isShowContactEditPopup (newOne) {
            this.isShowContactEdit = newOne
        },
        isShow (val) {
            if (val) {
              this.initPage()
            }
        }
    }

}
</script>

<style lang="less" scoped>
#contactList.popup {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(100%, 0, 0);
    display: block;
}
#contactList.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#contactList.modal-out {
    transform: translate3d(100%, 0, 0);
}

.js-returnDetailBtn {
    position: absolute;
    width: 100%;
    text-align: center;
    height: 50px;
    line-height: 50px;
    background-color: #fff;
    z-index: 10;
    .returnButton {
        width: 30px;
        position: absolute;
        top: 4px;
        left: 20px;
        text-align: left;
        img {
            width: 33%;
        }
    }
    .popup-title {
        
        font-size: 14px;
        color: #333333;
        letter-spacing: 1px;
        margin: 0;
    }
}

.passenger-detail .detail-edit-img, .passenger-detail .detail-edit-intro, .passenger-detail .edit-img {
    display: inline-block;
    vertical-align: top;
}

.list-contacts-content {
    position: relative;
    width: 100%;
    top: 50px;
    height: calc(100% - 132px);
    background: #F6F7F8;
    z-index: 20;
    .contactsEdit-content {
        z-index: 20;
        background: #F6F7F8;
        position: relative;
        height: 100%;
        .fillPassenger-title {
            margin-bottom: 10px;
            padding: 13px 20px 13px;
            background-color: #fff;
            margin-top: 10px;
            .fillPassenger-title-l {
                display: inline-block;
                vertical-align: middle;
                font-size: 14px;
                line-height: 20px;
                color: #333;
            }
            .fillPassenger-title-r {
                display: inline-block;
                vertical-align: middle;
                float: right;
                font-size: 14px;
                line-height: 20px;
                color: #4A90E2;
                img {
                    width: 20px;
                    position: relative;
                    top: 5px;
                }
            }
        }
        .fillPassenger-desc {
          font-size: 14px;
          padding: 0 20px;
        }
        .passenger-details-content {

            margin-top: 10px;
            padding-top: 5px;
            height: calc(100% - 50px);
            overflow-y: scroll;
        }
        .passenger-details-content.is-desc {
          margin-top: 4px;
        }
        .passenger-detail {
            background: #fff;
            border-bottom: 1px dashed #E5E5E5;
            padding: 10px 0 15px 20px;
            .detail-edit-img {
                position: relative;
                top: 0px;
                img {
                    width: 16px;
                    margin-top: 2px;
                }
            }
            .detail-edit-intro {
                width: 286px;
                height: 40px;
                overflow: hidden;
                padding: 0 4px;
                .edit-intro-name {
                    font-size: 14px;
                    color: #000;
                    margin-bottom: 4px;
                    font-weight: bold;
                }
                .edit-intro-birth {
                    font-size: 12px;
                    line-height: 12px;
                    color: #666;
                    .male {
                        display: inline-block;
                        padding-right: 13px;
                    }
                    .birth {
                        padding-left: 13px;
                        padding-right: 13px;
                        border-left: 1px solid #999;
                    }
                    .passenger-passport {
                        padding-left: 13px;
                        border-left: 1px solid #999;
                    }
                }
            }
            .edit-img {
                padding: 4px 20px 4px 10px;
                img {
                    width: 20px;
                }
            }
        }
    }

    .selectAddContacts {
        position: fixed;
        bottom: 0px;
        background-image: -webkit-gradient(linear, right top, left top, from(#FAD961), to(#FEBC10));
        background-image: -webkit-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
        background-image: -moz-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
        background-image: -o-linear-gradient(right, #FAD961 0%, #FEBC10 100%);
        background-image: linear-gradient(270deg, #FAD961 0%, #FEBC10 100%);
        color: #454545;
        font-size: 16px;
        text-align: center;
        padding: 13px 0;
        width: 100%;
        margin: 0 auto;
    }


}
</style>
